import { z } from 'zod';
import { requiredUrlSchema } from '@/lib/utils/url-schema.utils';
import { CONFIRM_STARTUP_STRINGS as S } from './constants';

/** "Confirm your startup" (FR-225): both fields required, the website normalized to https://. */
export const confirmStartupSchema = z.object({
  companyName: z.string().trim().min(1, S.NAME_REQUIRED).max(200),
  companyWebsiteUrl: requiredUrlSchema(S.WEBSITE_REQUIRED),
});

export type ConfirmStartupFormValues = z.input<typeof confirmStartupSchema>;
export type ConfirmStartupPayloadValues = z.output<typeof confirmStartupSchema>;
